module.exports = __webpack_public_path__ + "img/brand19.6b4cc5c6.png";